import { WbsFrontend } from '@interserve/igx-angular'

/**
 * 現在使っているサンプルデータ
 * @description この中のデータは全て利用できる設定値です。
 */

export const AreaMappingHubData: WbsFrontend = {
    layout: {
        header: {
            label: 'エリアを追加',
        },
        footer: {
            buttons: [
                {
                    key: 'cancel',
                    label: 'キャンセル',
                    color: 'cancel',
                    disable: false,
                    action: 'close',
                },
                {
                    key: 'select',
                    label: '選択',
                    color: 'primary',
                    disable: false,
                    action: 'select',
                },
            ],
        },
        leftWbs: {
            type: 'grid',
        },
        leftWbsRules: {
            childDataKey: '',
            hideHeader: false,
            height: '300px',
            width: '100%',
            rowSelection: 'multiple',
            noSelectionWbsTypes: ['plusButton'],
            canAddElement: true,
            addElementType: 'area',
            canUseAddDialog: true,
            fields: [
                {
                    name: 'name',
                    label: '名称',
                    width: '100%',
                    dataType: 'string',
                },
            ],
        },
    },
    // actions: {
    //     loadHub: {
    //         event: 'onLoadHub',
    //         defaultData: [],
    //         // apiInfo: {
    //         //   url: 'http://test/api/wbs/cassette/{cassetteId}',
    //         // },
    //     },
    // },
}
export const SimulationMappingData: WbsFrontend = {
    layout: {
        style: {
            direction: 'row', // row | column
        },
        leftWbs: {
            type: 'grid',
        },
        leftWbsRules: {
            childDataKey: 'nodeObjects',
            hideHeader: true,
            rowSelection: 'single',
            hideRowSelectors: true,
            canMoveTopNode: false,
            height: '300px',
            width: '100%',
            fields: [
                {
                    name: 'name',
                    label: '名前',
                    dataType: 'string',
                },
            ],
        },
        rightWbs: {
            type: 'grid',
        },
        rightWbsRules: {
            childDataKey: 'nodeObjects',
            hideHeader: true,
            rowSelection: 'single',
            hideRowSelectors: true,
            height: '300px',
            width: '100%',
            fields: [
                {
                    name: 'name',
                    label: '名前',
                    dataType: 'string',
                },
            ],
        },
        footer: {
            buttons: [
                {
                    key: 'cancel',
                    label: '元に戻す',
                    color: 'cancel',
                    disable: false,
                    action: 'revert',
                },
                {
                    key: 'register',
                    label: '登録する',
                    color: 'primary',
                    disable: false,
                    action: 'saveButton',
                },
            ],
        },
        actionRules: {
            regist: [
                {
                    items: {},
                },
            ],
            delete: [
                {
                    items: {},
                },
            ],
            leftArrow: [
                {
                    event: 'forward',
                    conditions: [
                        {
                            key: 'rightSelected.wbsType',
                            value: ['cassette'],
                        },
                    ],
                },
            ],
            rightArrow: [
                {
                    event: 'backward',
                    conditions: [
                        {
                            key: 'leftSelected.wbsType',
                            value: ['cassette'],
                        },
                    ],
                },
            ],
            saveButton: [
                {
                    event: 'showSaveDialog',
                    items: {
                        messageCd: 'confirmRun',
                    },
                },
            ],
        },
    },
}
export const SimulationStaticLeftWbs: any[] = [
    {
        userSource: 'text',
        // "authDivision": 1,
        // "ownId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
        wbsType: 'title',
        ownerId: '486e1159-b3c6-48e0-ae9c-e523ee5a779c',
        // "creatorId": "b9de8178-baaf-4f3f-9ab4-d246d4f354e2",
        // "creatorName": "熊川",
        id: 'd24086a9-55f3-4329-a230-797ca71e05bb',
        name: '作業日',
        nodeObjects: [
            {
                userSource: 'text',
                // "authDivision": 1,
                // "ownId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
                wbsType: 'area',
                parentId: 'd24086a9-55f3-4329-a230-797ca71e05bb',
                // "ownerId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
                // "creatorId": "b9de8178-baaf-4f3f-9ab4-d246d4f354e2",
                // "createdAt": "2024-01-17T03:14:05.0508843+00:00",
                // "lastUpdatedAt": "2024-01-17T03:14:05.0508843+00:00",
                id: '86cf520e-982e-41fd-97e0-b68398ae5ef5',
                name: '3/4(月)',
            },
            {
                userSource: 'text',
                // "authDivision": 1,
                // "ownId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
                wbsType: 'area',
                parentId: 'd24086a9-55f3-4329-a230-797ca71e05bb',
                // "ownerId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
                // "createdAt": "2024-01-22T02:47:18.8884505+00:00",
                // "lastUpdatedAt": "2024-02-26T02:45:29.6055579+00:00",
                id: '9602094a-2204-4b3a-a0c3-e1500f3c2168',
                name: '3/5(火)',
            },
        ],
    },
]
export const SimulationStaticRightWbs: any[] = [
    {
        userSource: 'text',
        // "authDivision": 1,
        // "ownId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
        wbsType: 'title',
        // "ownerId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
        // "creatorId": "b9de8178-baaf-4f3f-9ab4-d246d4f354e2",
        // "creatorName": "熊川",
        id: '97cd4b8c-d292-4c99-9183-05f28fdf6407',
        name: '納品日',
        nodeObjects: [
            {
                userSource: 'organization',
                // "authDivision": 1,
                // "ownId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
                wbsType: 'cassette',
                parentId: '97cd4b8c-d292-4c99-9183-05f28fdf6407',
                // "ownerId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
                // "createdAt": "2024-02-29T00:18:10.008067+00:00",
                // "lastUpdatedAt": "2024-02-29T00:24:25.0876032+00:00",
                id: '6b4a7cb2-79d5-49a9-9f7e-5b403023b4d7',
                name: '3/5(火)',
                nodeObjects: [
                    {
                        userSource: 'organization',
                        // "authDivision": 1,
                        // "ownId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
                        wbsType: 'cassette',
                        parentId: '6b4a7cb2-79d5-49a9-9f7e-5b403023b4d7',
                        // "ownerId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
                        // "createdAt": "2024-02-29T00:19:35.210758+00:00",
                        // "lastUpdatedAt": "2024-02-29T00:19:35.210758+00:00",
                        id: 'cdfb8e03-c538-4dd0-a0ec-09b6b40f7ba2',
                        name: '新店',
                    },
                    {
                        userSource: 'organization',
                        // "authDivision": 1,
                        // "ownId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
                        wbsType: 'cassette',
                        parentId: '6b4a7cb2-79d5-49a9-9f7e-5b403023b4d7',
                        // "ownerId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
                        // "createdAt": "2024-02-29T00:19:35.210758+00:00",
                        // "lastUpdatedAt": "2024-02-29T00:19:35.210758+00:00",
                        id: 'b93936ad-cbd1-49f9-8ac9-66b040b03d2b',
                        name: '客注',
                    },
                    {
                        userSource: 'organization',
                        // "authDivision": 1,
                        // "ownId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
                        wbsType: 'cassette',
                        parentId: '6b4a7cb2-79d5-49a9-9f7e-5b403023b4d7',
                        // "ownerId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
                        // "createdAt": "2024-02-29T00:19:35.210758+00:00",
                        // "lastUpdatedAt": "2024-02-29T00:19:35.210758+00:00",
                        id: 'b658bf86-292d-4f71-bc4a-9a3d8f53914e',
                        name: 'EC',
                    },
                ],
            },
            {
                userSource: 'text',
                // "authDivision": 1,
                // "ownId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
                wbsType: 'cassette',
                parentId: '97cd4b8c-d292-4c99-9183-05f28fdf6407',
                // "ownerId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
                // "creatorId": "b9de8178-baaf-4f3f-9ab4-d246d4f354e2",
                // "createdAt": "2024-01-17T03:14:05.0508843+00:00",
                // "lastUpdatedAt": "2024-01-17T03:14:05.0508843+00:00",
                id: 'f2b66720-2ab2-491f-a8f1-a555e2be61bb',
                name: '3/6(水)',
                nodeObjects: [
                    {
                        userSource: 'organization',
                        // "authDivision": 1,
                        // "ownId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
                        wbsType: 'cassette',
                        parentId: 'f2b66720-2ab2-491f-a8f1-a555e2be61bb',
                        // "ownerId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
                        // "createdAt": "2024-02-29T00:19:35.210758+00:00",
                        // "lastUpdatedAt": "2024-02-29T00:19:35.210758+00:00",
                        id: 'e2f996ae-456a-4f63-a4f7-7d9af54acfd4',
                        name: '新店',
                    },
                    {
                        userSource: 'organization',
                        // "authDivision": 1,
                        // "ownId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
                        wbsType: 'cassette',
                        parentId: 'f2b66720-2ab2-491f-a8f1-a555e2be61bb',
                        // "ownerId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
                        // "createdAt": "2024-02-29T00:19:35.210758+00:00",
                        // "lastUpdatedAt": "2024-02-29T00:19:35.210758+00:00",
                        id: '3f7d7b70-61bf-4eff-ae23-783071e51d84',
                        name: '客注',
                    },
                    {
                        userSource: 'organization',
                        // "authDivision": 1,
                        // "ownId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
                        wbsType: 'cassette',
                        parentId: 'f2b66720-2ab2-491f-a8f1-a555e2be61bb',
                        // "ownerId": "486e1159-b3c6-48e0-ae9c-e523ee5a779c",
                        // "createdAt": "2024-02-29T00:19:35.210758+00:00",
                        // "lastUpdatedAt": "2024-02-29T00:19:35.210758+00:00",
                        id: '75893468-798c-4d1e-a32f-e40c813a52ba',
                        name: '通常',
                    },
                ],
            },
        ],
    },
]
export const selectDataHubInfo: WbsFrontend = {
    layout: {
        header: {
            label: 'どれをテストデータとして使いますか？',
        },
        leftWbs: {
        },
        leftWbsRules: {
            childDataKey: '',
            hideHeader: false,
            height: '300px',
            width: '100%',
            rowSelection: 'multiple',
            fields: [
                {
                    name: 'name',
                    label: '名称',
                    width: 'calc(100% - 60px)',
                    dataType: 'string',
                },
            ],
        },
        footer: {
            buttons: [
                {
                    key: 'cancel',
                    label: 'キャンセル',
                    color: 'cancel',
                    disable: false,
                    action: 'close',
                },
                {
                    key: 'select',
                    label: '選択',
                    color: 'primary',
                    disable: false,
                    action: 'select',
                },
            ],
        },
    },
}
export const selectDataHub: any[] = [
    {
        id: '86cf520e-982e-41fd-97e0-b68398ae5ef5',
        name: '3/5 データ',
    },
    {
        id: '58529c21-ce8e-47b1-9668-b88068dc089e',
        name: '4/5 テストデータ',
    },
    {
        id: 'c28cfbeb-911b-45d2-a9d5-f3ddfcb37621',
        name: 'is ホームセンターデモ',
    },
    {
        id: '928b37b7-ead2-4377-9c1b-b0e0a4517dc9',
        name: 'is---デモ',
    },
]
